<template>
  <div class="bottom-add-btn">
    <router-link class="bottom-add-btn__inner" :to="to" tabindex="-1">
      <span :class="icon"></span>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    to: String,
    icon: {
      type: String,
      default: 'iconfont icon-add'
    }
  }
};
</script>

<style>
.bottom-add-btn {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 1.5;
  position: fixed;
  right: 50%;
  margin-right: -25px;
  bottom: 20px;
  z-index: 10;
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.bottom-add-btn__inner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  color: #07c160;
  font-size: 18px;
  box-shadow: 0 1px 3px #07c160;
    /* background-color: #fff; */
  background-color: var(--weui-BG-2);
}
</style>